import { defineMessages } from 'react-intl';

export default defineMessages({
  flaggedComments: 'Flagged comments',
  resolve: 'Resolve',
});
